
import { Component, Vue, Prop, Watch } from "vue-property-decorator";

import {
  orderFinish,
  orderRemind,
  checkOrderRefuseAcceptComplete,
} from "@/api/order";
import bbsDialog from "@/components/BbsDialog/index.vue";
import confirmDialog from "@/components/confirmCloseAndRefuseDialog/confirmCloseAndRefuseDialog.vue";
import { UserModule } from "@/store/modules/user";
import eventBus from "@/utils/eventBus";
import { checkPermissionUseAndCompany } from "@/utils/permission";
import { Type } from "@/types/permissionType";

@Component({
  name: "BtnGroup",
  components: {
    bbsDialog,
    confirmDialog,
  },
})
export default class extends Vue {
  @Prop({
    type: Object,
    default: () => ({}),
    required: true,
  })
  operationData!: any;
  @Prop({
    type: Boolean,
    default: false,
    required: true,
  })
  all!: any;

  // 七牛
  private qiuniuToken: any = {};

  private nowId: number = -1;
  private nowSid: number = -1;
  private bbsDialogVisible: boolean = false;
  private state: any;

  private confirmDialogVisible: any = false;
  private dialogMsg: string = "";
  private operationType!: string;

  private customHeight = window.innerHeight * 0.4;

  private btnList: Record<string, boolean> = {};
  @Watch("operationData", {
    deep: true,
    immediate: true,
  })
  handleChangeProps() {
    /**
     * 按钮需要在每次props改变后更新
     */
    const orderState = parseInt((this.operationData as any).order.state);
    this.state = orderState;
    let closePermission = false;
    let finishPermission = false;
    if (
      this.operationData &&
      this.operationData.order &&
      (this.operationData.order.create_user_id === UserModule.getUserId ||
        this.operationData.order.customer_user_id === UserModule.getUserId)
    ) {
      closePermission = true;
      finishPermission = true;
    } else {
      closePermission = checkPermissionUseAndCompany(
        UserModule.getCompanyId,
        Type.CloseOrder
      );
      finishPermission = checkPermissionUseAndCompany(
        UserModule.getCompanyId,
        Type.FinishOrder
      );
    }
    /**
     * 按钮列表显示权限判断
     */

    this.btnList = {
      bbs: true && !this.all,
      remind: [1, 2, 3, 5].includes(orderState) && !this.all,
      finish:
        [1, 2, 3, 5].includes(orderState) &&
        (parseInt(this.operationData.order_service.is_task_finish) === 1 && parseInt(this.operationData.order_service.state) != 553) &&
        finishPermission,
      close: [1, 2, 3, 5].includes(orderState) && closePermission,
      send:
        (this.operationData as any).order.task_send !== undefined &&
        parseInt((this.operationData as any).order.task_send.state) ===
          550330 &&
        !this.all,
      evaluation:
        parseInt((this.operationData as any).order.order_type) !== 4 &&
        orderState === 7 &&
        (this.operationData as any).order_service.order_task_count > 0 &&
        this.getNewOvl(),
      modifyevaluation:parseInt((this.operationData as any).order.order_type) !== 4 &&
        orderState > 7 &&
        (this.operationData as any).order_service.order_task_count > 0 &&
        this.getNewModifyOvl(),
      // 工作单都不显示
      exportPdf:
        (this.operationData as any).order.order_elec !== null && !this.all,
      refuse:
        [1, 2, 3, 5].includes(orderState) &&
        (parseInt(this.operationData.order_service.is_task_finish) === 1 && parseInt(this.operationData.order_service.state) != 553) &&
        parseInt(this.operationData.order.is_set_refuse_complete) === 1 &&
        parseInt(this.operationData.order_service.is_refuse_accept_complete) ===
          0 &&
        finishPermission,
    };
  }
  private getNewModifyOvl() {
    let flag = false;
    flag =this.all&&
        parseInt(this.operationData.order_service.is_open_diy_evaluate) === 1 &&
        parseInt(this.operationData.order.evaluate_state) === 1 &&
        checkPermissionUseAndCompany(
          UserModule.getCompanyId,
          Type.OrderEvaluate
        );
    return flag;
  }
  private getNewOvl() {
    let flag = false;
    if (this.all) {
      flag =
        parseInt(this.operationData.order_service.is_open_diy_evaluate) === 1 &&
        parseInt(this.operationData.order_service.diy_evaluate_user_type) ===
          2 &&
        checkPermissionUseAndCompany(
          UserModule.getCompanyId,
          Type.OrderEvaluate
        );
    } else {
      if (
        parseInt(this.operationData.order_service.is_open_diy_evaluate) === 1
      ) {
        flag =
          parseInt(this.operationData.order_service.diy_evaluate_user_type) ===
          1;
      } else {
        flag = true;
      }
    }
    return flag;
  }
  // 催单操作
  remindHandle(r: any) {
    this.$confirm("确认催单？", "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning",
    })
      .then(() => {
        const params = {
          user_id: UserModule.getUserId,
          user_name: UserModule.getUserName,
          company_id: UserModule.getCompanyId ? UserModule.getCompanyId : "0",
          order_id: r.order.id,
        };
        orderRemind(params)
          .then((res: any) => {
            this.$notify({
              title: "提示",
              message: (res as any).msg,
              offset: this.customHeight,
              customClass: "notification-center",
              type: "success",
            });
          })
          .catch((err: any) => {
            // this.showErrorMsg(err.msg);
            this.$notify({
              title: "提示",
              message: (err as any).msg,
              offset: this.customHeight,
              customClass: "notification-center",
              type: "error",
            });
          });
      })
      .catch(() => {});
  }

  /**
   * 验收完成
   */
  finishHandle(r: any) {
    /**
     * 验收完成需要多一步判断，该订单下是否有工程师仍在工作，提示内容不一样
     * 1、该订单下有工程师未完成：当前订单下还有x个维修人员未处理完成，是否验收订单？
     * 2、订单审核中，无法验收完成
     * 3、可以验收完成
     */
    const num = r.order.unfinish_order_task_num;
    let title = "";
    if (num > 0) {
      title = `当前订单下还有${num}个维修人员未处理完成，是否验收完成？`;
    } else if (r.order.check_state > 0 && r.order.check_state <= 51) {
      title = "订单审核中，无法验收完成";
    } else {
      title = "确认完成此订单？";
    }

    this.$confirm(title, "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning",
    })
      .then(() => {
        const params = {
          user_id: UserModule.getUserId,
          user_name: UserModule.getUserName,
          company_id: UserModule.getCompanyId ? UserModule.getCompanyId : "0",
          order_id: r.order.id,
        };
        orderFinish(params)
          .then((res: any) => {
            this.$notify({
              title: "提示",
              message: (res as any).msg,
              offset: this.customHeight,
              customClass: "notification-center",
              type: "success",
            });
            setTimeout(() => {
              eventBus.$emit("orderSearch");
            }, 500);
          })
          .catch((err: any) => {
            this.showErrorMsg(err.msg);
          });
      })
      .catch(() => {});
  }

  /**
   * 订单评价
   */
  evaluateHandle(r: any) {
    if (parseInt(r.order_service.is_open_diy_evaluate) === 1) {
      this.$router.push({
        path: "/order/evaluateOrder",
        query: { evaluateData: JSON.stringify(r) },
      });
    } else {
      this.$router.push({
        path: "/order/evaluate",
        query: { evaluateData: JSON.stringify(r) },
      });
    }
  }
  modifyEvaluateHandle(r:any){
    this.$router.push({
        path: "/order/evaluateOrder",
        query: { evaluateData: JSON.stringify(r),isModify:'1' },
      });
  }

  /**
   * 马上寄送
   */
  sendHandle(r: any) {
    let a: any = [];
    a.push(r);
    this.$router.push({
      path: "/order/send",
      query: { orderDetailList: JSON.stringify(a) },
    });
  }

  /**
   * 点击按钮弹出提示窗
   */
  confirmHandle(r: any, msg: string, type: string) {
    this.confirmDialogVisible = true;
    this.dialogMsg = msg;
    this.operationType = type;
  }
  // 拒绝验收
  refuseHandle() {
    this.dialogMsg = "拒绝验收";
    this.operationType = "refuse";
    const params: any = {
      company_id: UserModule.getCompanyId ? UserModule.getCompanyId : "0",
      order_service_id: this.operationData.order_service.id,
    };
    checkOrderRefuseAcceptComplete(params)
      .then((res: any) => {
        if (res.data && parseInt(res.data.is_refuse_accept_complete) === 1) {
          this.qiuniuToken = res.data.uptoken;
          this.confirmDialogVisible = true;
        } else {
          this.$notify({
            title: "提示",
            message: "有任务未完成,不能拒绝验收",
            offset: this.customHeight,
            customClass: "notification-center",
            type: "error",
          });
        }
      })
      .catch((err) => {
        let msg = err.msg;
        // this.showErrorMsg(err.msg);
      });
  }
  /**
   * 点击提示窗上面的确定按钮
   */
  handleDialogConfirm() {
    this.confirmDialogVisible = false;
    eventBus.$emit("orderSearch");
  }

  bbsHandle(r: any) {
    this.nowId = parseInt(r.order.id);
    this.nowSid = parseInt(r.order_service.id);
    this.bbsDialogVisible = true;
  }

  exportHandle(r: any) {
    // 工作单导出
    const url = r.order.order_elec.save_path as string;
    const filename = url.split("/").slice(-1)[0];
    try {
      if ("download" in document.createElement("a")) {
        // 非IE下载
        let elink = document.createElement("a");
        elink.download = filename;
        elink.style.display = "none";
        elink.href = url;
        elink.target = "_blank";
        document.body.appendChild(elink);
        elink.click();
        URL.revokeObjectURL(elink.href); // 释放URL 对象
        document.body.removeChild(elink);
      } else {
        // IE10+下载
        // navigator.msSaveBlob(blob, fileName);
      }
      this.$message.success("下载文件成功");
    } catch (err) {
      let msg = "";
    }
  }

  private showErrorMsg(msg: string) {
    this.$notify({
      title: "提示",
      message: msg,
      offset: 100,
      type: "error",
    });
  }

  private showSuccessMsg(msg: string) {
    this.$notify({
      title: "提示",
      message: msg,
      offset: 100,
      type: "success",
    });
  }

  closeBbs(value: boolean) {
    this.bbsDialogVisible = value;
  }
  private closeConfirmDialog(value: boolean) {
    this.confirmDialogVisible = value;
  }
}
